import React, { type FC } from 'react';
import { Autoplay, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { CustomSlide } from './components';
import type { CustomSliderProps } from './types';

const CustomSlider: FC<CustomSliderProps> = ({ items, title }) => {
    const breakpoints = {
        768: {
            slidesPerView: 2,
            slidesPerGroup: 2,
        },
        1200: {
            slidesPerView: 2.5,
            slidesPerGroup: 2,
        },
        1400: {
            slidesPerView: 3,
            slidesPerGroup: 3,
        },
    };

    return (
        <div className="py-8">
            <h4 className="text-3xl px-2">{title}</h4>
            <div className="py-6">
                <Swiper
                    pagination={{
                        clickable: true,
                        renderBullet: (index, className) => `<div class="${className}"></div>`,
                    }}
                    modules={[Pagination, Autoplay]}
                    breakpoints={breakpoints}
                    slidesPerGroup={1}
                    slidesPerView={1.15}
                    speed={1000}
                    autoplay={{
                        delay: 2000,
                        disableOnInteraction: false,
                    }}
                    spaceBetween={20}
                    runCallbacksOnInit
                >
                    {items.map((articleInfoItem, index) => (
                        <SwiperSlide className={'mb-8'} draggable={false} key={`article-slide-${index + 1}`}>
                            <CustomSlide item={articleInfoItem} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
};

export default CustomSlider;
